export default __webpack_public_path__ + "static/1254-40b663e853c0d7b86b301f90772c688d.gif";